
    <template>
      <section class="content example-md-doc">
        <h2>Quick Start</h2>
<anchor is-edit label="npm & yarn" fileName="start.md" />
        <pre><code class="language-javascript">npm install vue-easytable
</code></pre>
<p>or</p>
<pre><code class="language-javascript">yarn add vue-easytable
</code></pre>
<anchor is-edit label="Usage" fileName="start.md" />
        <h4>Fully import</h4>
<p>Write the following in main.js：</p>
<pre><code class="language-javascript">import Vue from &quot;vue&quot;;
import &quot;vue-easytable/libs/theme-default/index.css&quot;; // import style
import VueEasytable from &quot;vue-easytable&quot;; // import library

Vue.use(VueEasytable);

new Vue({
    el: &quot;#app&quot;,
    render: (h) =&gt; h(App),
});
</code></pre>
<p>The above code completes the introduction of vue-easytable.Don't forget to import style files.</p>
<h4>On demand</h4>
<p>Write the following in main.js：</p>
<pre><code class="language-javascript">import Vue from &quot;vue&quot;;
import &quot;vue-easytable/libs/theme-default/index.css&quot;; // import style

import { VeTable, VePagination, VeIcon, VeLoading, VeLocale } from &quot;vue-easytable&quot;; // import library

Vue.use(VeTable);
Vue.use(VePagination);
Vue.use(VeIcon);
Vue.use(VeLoading);

Vue.prototype.$veLoading = VeLoading;
Vue.prototype.$veLocale = VeLocale;

new Vue({
    el: &quot;#app&quot;,
    render: (h) =&gt; h(App),
});
</code></pre>
<h4>Example</h4>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    { field: &quot;name&quot;, key: &quot;a&quot;, title: &quot;Name&quot;, align: &quot;center&quot; },
                    { field: &quot;date&quot;, key: &quot;b&quot;, title: &quot;Date&quot;, align: &quot;left&quot; },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;right&quot;,
                    },
                    { field: &quot;address&quot;, key: &quot;d&quot;, title: &quot;Address&quot; },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block><anchor is-edit label="Usage By CDN" fileName="start.md" />
        <p>Through <a href="https://unpkg.com/vue-easytable/">https://unpkg.com/vue-easytable/</a>, you can see the resources of the latest version of Vue easytable,You can also switch versions to select the required resources,You can start using JS and CSS files on the page</p>
<pre><code class="language-css">&lt;!-- import style --&gt;
&lt;link rel=&quot;stylesheet&quot; href=&quot;https://unpkg.com/vue-easytable/libs/theme-default/index.css&quot;&gt;
&lt;!-- import Vue --&gt;
&lt;script src=&quot;https://cdn.jsdelivr.net/npm/vue@2&quot;&gt;&lt;/script&gt;
&lt;!-- import library --&gt;
&lt;script src=&quot;https://unpkg.com/vue-easytable/libs/umd/index.js&quot;&gt;&lt;/script&gt;
</code></pre>
<h4>Example</h4>
<pre><code class="language-html">&lt;!DOCTYPE html&gt;
&lt;html&gt;
    &lt;head&gt;
        &lt;meta charset=&quot;UTF-8&quot; /&gt;
        &lt;!-- import style --&gt;
        &lt;link
            rel=&quot;stylesheet&quot;
            href=&quot;https://unpkg.com/vue-easytable/libs/theme-default/index.css&quot;
        /&gt;
    &lt;/head&gt;
    &lt;body&gt;
        &lt;div id=&quot;app&quot;&gt;
            &lt;ve-table :columns=&quot;columns&quot; :table-data=&quot;tableData&quot;&gt;&lt;/ve-table&gt;
        &lt;/div&gt;
    &lt;/body&gt;
    &lt;!-- import Vue --&gt;
    &lt;script src=&quot;https://cdn.jsdelivr.net/npm/vue@2&quot;&gt;&lt;/script&gt;
    &lt;!-- import library --&gt;
    &lt;script src=&quot;https://unpkg.com/vue-easytable/libs/umd/index.js&quot;&gt;&lt;/script&gt;
    &lt;script&gt;
        new Vue({
            el: &quot;#app&quot;,
            data: function () {
                return {
                    columns: [
                        {
                            field: &quot;name&quot;,
                            key: &quot;a&quot;,
                            title: &quot;Name&quot;,
                            align: &quot;center&quot;,
                        },
                        {
                            field: &quot;date&quot;,
                            key: &quot;b&quot;,
                            title: &quot;Date&quot;,
                            align: &quot;left&quot;,
                        },
                        {
                            field: &quot;hobby&quot;,
                            key: &quot;c&quot;,
                            title: &quot;Hobby&quot;,
                            align: &quot;right&quot;,
                        },
                        { field: &quot;address&quot;, key: &quot;d&quot;, title: &quot;Address&quot; },
                    ],
                    tableData: [
                        {
                            name: &quot;John&quot;,
                            date: &quot;1900-05-20&quot;,
                            hobby: &quot;coding and coding repeat&quot;,
                            address: &quot;No.1 Century Avenue, Shanghai&quot;,
                        },
                        {
                            name: &quot;Dickerson&quot;,
                            date: &quot;1910-06-20&quot;,
                            hobby: &quot;coding and coding repeat&quot;,
                            address: &quot;No.1 Century Avenue, Beijing&quot;,
                        },
                        {
                            name: &quot;Larsen&quot;,
                            date: &quot;2000-07-20&quot;,
                            hobby: &quot;coding and coding repeat&quot;,
                            address: &quot;No.1 Century Avenue, Chongqing&quot;,
                        },
                        {
                            name: &quot;Geneva&quot;,
                            date: &quot;2010-08-20&quot;,
                            hobby: &quot;coding and coding repeat&quot;,
                            address: &quot;No.1 Century Avenue, Xiamen&quot;,
                        },
                        {
                            name: &quot;Jami&quot;,
                            date: &quot;2020-09-20&quot;,
                            hobby: &quot;coding and coding repeat&quot;,
                            address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                        },
                    ],
                };
            },
        });
    &lt;/script&gt;
&lt;/html&gt;
</code></pre>
<anchor is-edit label="Browser Compatible" fileName="start.md" />
        <p>Support modern browser and ie10 and above</p>

      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    { field: "name", key: "a", title: "Name", align: "center" },
                    { field: "date", key: "b", title: "Date", align: "left" },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "right",
                    },
                    { field: "address", key: "d", title: "Address" },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  